import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderRailyTaxiDraft from "./billings-order-raily-taxi-draft";
import BillingsOrderRailyTaxiDraftParams from "./billings-order-raily-taxi-draft-params";

const useBillingsOrderRailyTaxiDraft = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderRailyTaxiDraft | null>(null);

  const load = async (
    params: BillingsOrderRailyTaxiDraftParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getOrderRailyTaxiBillingsDraft(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderRailyTaxiDraft;
